import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentsSidebarFilterSearchTagsItem from './VeltCommentsSidebarFilterSearchTagsItem/VeltCommentsSidebarFilterSearchTagItem';
var VeltCommentsSidebarFilterSearchTags = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterSearchTags.Item = VeltCommentsSidebarFilterSearchTagsItem;
export default VeltCommentsSidebarFilterSearchTags;
